import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';
import { ILineItemResultMap } from '../../../models';
import { flatten } from '@angular/compiler';

@Component({
  selector: 'app-edit-email-address',
  templateUrl: './edit-email-address.component.html',
  styleUrls: ['./edit-email-address.component.scss']
})
export class EditEmailAddressComponent implements OnInit {

  public title !: string;
  public marketResults !: any;
  public onClose = new BehaviorSubject<any>({});
  public vendor_list !:any;
  public emails !: any;
  public vendorCode !:any;

 
  public marketResultForm !: FormGroup;
  supplierMarketResult:any = [];
  selectedVendor:any;
  public uniqueVendors:any

  constructor(
    public bsModalRef: BsModalRef,
    private _fb : FormBuilder) { }

  ngOnInit(): void {
    if(this.marketResults) {
      this.marketResults.map((marketResults:any)=>{
        this.supplierMarketResult.push(flatten(marketResults.supplierMarketResult))
      });
      this.vendor_list = flatten(this.supplierMarketResult).map((sup:any)=>{return {code:sup.VENDOR_CODE, email:sup.EMAIL_ADDRESS?sup.EMAIL_ADDRESS:'-', isSelected:sup.isChecked}});
      const selectedVendor = this.vendor_list.filter((vendor:any)=> vendor.isSelected);
     
      if(selectedVendor.length){
        this.selectedVendor = selectedVendor;
      } else {
       this.selectedVendor = this.vendor_list;      
      }

      this.uniqueVendors = this.selectedVendor.filter((value:any, index:any) => {
        const strValue = JSON.stringify(value);
        return index === this.selectedVendor.findIndex((obj:any) => {
          return JSON.stringify(obj) === strValue;
        });
      });

    }
  }

  public updateEmailInfo(){
    this.marketResults.map((supplierMarketRes:any)=>{
      supplierMarketRes.supplierMarketResult.map((sup:any)=>{
        if(this.vendorCode == sup.VENDOR_CODE){
          sup.EMAIL_ADDRESS = this.emails?.map((email: any) => email.value ? email.value : email).toString()
          sup.R3_S_EMAIL_ADDRESS = this.emails?.map((email: any) => email.value ? email.value : email).toString()
        }
      })
    })
    console.log("this.marketResults",this.marketResults);
    this.bsModalRef.hide();
  }

  public onVendorSelect(event: any) {
    console.log(event.target.value);
    this.vendorCode = event.target.value
    this.vendor_list.map((vendor: any) => {
      if (vendor.code == this.vendorCode && vendor.email !== '-') {
        if (vendor.email.includes(',')) {
          this.emails = vendor.email.split(",");
        } else {
          this.emails = [vendor.email]
        }
      }
      return vendor.email.includes(',') ? vendor.email.split(",") : vendor.email;
    });
    console.log(this.emails)
    this.emails = this.emails.filter((email: any) => email != undefined);
  }

}
